// plugins/focusTrapDirective.js
import { createFocusTrap } from "focus-trap"

const focusableSel = ["button:not([disabled])", "[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", '[tabindex]:not([tabindex="-1"])'].join(",")

function resolveInitial(el) {
    const marker = el.querySelector("[data-focus-first]")
    if (marker) {
        const inner = marker.querySelector("input, " + focusableSel)
        return inner || marker
    }
    return el.querySelector(focusableSel) || el
}

export default {
    install(Vue) {
        Vue.directive("focus-trap", {
            inserted(el, binding) {
                el.__focusTrap = createFocusTrap(el, {
                    initialFocus: () => resolveInitial(el),
                    fallbackFocus: el,
                    escapeDeactivates: true,
                    allowOutsideClick: true,
                    returnFocusOnDeactivate: true // ⟵ Fokus an den Opener zurückgeben
                })

                if (binding.value) {
                    // Opener cachen (zusätzliche Absicherung)
                    el.__opener = document.activeElement
                    Promise.resolve().then(() => el.__focusTrap?.activate())
                }
            },
            update(el, binding) {
                if (!el.__focusTrap) return

                // wurde geöffnet?
                if (binding.value && !binding.oldValue) {
                    el.__opener = document.activeElement // ⟵ Opener merken
                    Promise.resolve().then(() => el.__focusTrap?.activate())
                }
                // wurde geschlossen?
                else if (!binding.value && binding.oldValue) {
                    el.__focusTrap.deactivate() // focus-trap versucht schon zu restoren
                    // Fallback: wenn aus irgendeinem Grund nicht geklappt hat
                    if (el.__opener && typeof el.__opener.focus === "function") {
                        // kleine Verzögerung, falls DOM gerade re-rendert
                        setTimeout(() => el.__opener && el.__opener.focus(), 0)
                    }
                }
            },
            unbind(el) {
                el.__focusTrap?.deactivate()
                el.__focusTrap = null
                el.__opener = null
            }
        })
    }
}
